import { useEffect, useState } from 'react';
import { obtenerInfoListaPrecintosChecklistSalida } from '../api/checklist';

const ModalPrecinto = ({ isOpen, id, onClose }) => {
    const [listaPrecintos, setListaPrecintos] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (isOpen && id) {
            fetchData();
        }
    }, [isOpen, id]);

    const fetchData = async () => {
        setIsLoading(true);
        setError(null);

        try {
            // Replace with your actual API endpoint
            const infoExtraPrecintos = await obtenerInfoListaPrecintosChecklistSalida({ idChecklist: id })
            // console.log('infoExtraPrecintos');
            // console.log(infoExtraPrecintos)
            setListaPrecintos(infoExtraPrecintos);
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md max-h-[80vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold">Precintos:</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>

                {isLoading ? (
                    <div className="flex justify-center py-8">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
                    </div>
                ) : error ? (
                    <div className="text-red-500 py-4">{error}</div>
                ) : (
                    <ul className="space-y-2">
                        {listaPrecintos.map((item) => (
                            <li key={item.id} className="p-2 border-b border-gray-100">
                                {item.precinto}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default ModalPrecinto;